export default __webpack_public_path__ + "static/media/view-onclick.8f44be81.svg";